<template>
  <div>
    <v-col align="center" class="share-heading">
      Know someone who’ll find this resource relevant?
    </v-col>
    <v-row class="ma-0" justify="center">
      <v-btn
        v-if="$store.state.isMobile"
        class="ma-2"
        outlined
        :href="whatsappUrl"
        data-action="share/whatsapp/share"
        target="_blank"
        color="#128C7E"
      >
        <v-icon left size="20">mdi-whatsapp</v-icon>
        <span class="btn-text"> Share on WhatsApp </span>
      </v-btn>

      <v-btn class="ma-2" color="#475993" outlined @click="facebookShare">
        <v-icon left size="20">mdi-facebook</v-icon>
        <span class="btn-text"> Share on Facebook </span>
      </v-btn>
      <v-btn class="ma-2" color="#1da2f1" outlined @click="twitterShare">
        <v-icon left size="20">mdi-twitter</v-icon>
        <span class="btn-text"> Share on Twitter </span>
      </v-btn>

      <v-btn color="#506CFF" class="ma-2" outlined @click="emailShare">
        <v-icon left size="20">mdi-email-outline</v-icon>
        <span class="btn-text"> Share via Email </span>
      </v-btn>
      <v-btn
        class="ma-2"
        color="#5271FF"
        @click="copyLink"
        elevation="0"
        outlined
      >
        <span class="btn-text">Copy link</span>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
  import AmplitudeHelper from "../../../amplitude";
  import Helper from "../../../helper";
  import ShareHelper from "../../../helper/share";
  import authToken from "../../../common/authToken";
  import { ROUTER_URL } from "../../../constants/urls";

  export default {
    name: "ShareSection",
    props: ["resourceDetails", "properties"],
    components: {},
    data() {
      return {
        whatsappUrl: null,
      };
    },
    created() {},
    computed: {},
    watch: {},
    methods: {
      makePublicLink(medium) {
        let props = this.$router.resolve({
          name: ROUTER_URL.publicResource.children.resourceDetails.name,
          params: {
            id: this.resourceDetails.id,
            title: this.resourceDetails.title.replace(/\s/g, "-"),
          },
          query: {
            utm_source: "Referral",
            utm_medium: medium,
            utm_campaign: "ShareResource",
          },
        });

        if (medium == "WhatsApp")
          return encodeURIComponent(window.location.origin + props.href);
        else return window.location.origin + props.href;
      },
      copyLink() {
        this.properties["share platform"] = "Copy Link";
        AmplitudeHelper.registerAmplitudeEvent(
          "share resource",
          this.properties
        );
        delete this.properties["share platform"];

        var text = window.location.href;

        // if (authToken.isCorrectAccessToken()) {
        //   let props = this.$router.resolve({
        //     name: ROUTER_URL.publicResource.children.resourceInvitation.name,
        //     params: {
        //       token: Helper.encryptData(
        //         JSON.stringify({
        //           id: this.resourceDetails.id,
        //           title: this.resourceDetails.title.replace(/\s/g, "-"),
        //         })
        //       ),
        //     },
        //   });

        //   text = window.location.origin + props.href;
        // } else {
        text = this.makePublicLink("CopiedLink");
        // }

        var dummy = document.createElement("input");
        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
        this.$store.dispatch("snackBar/showToast", {
          message: "Resource link copied.",
          color: "S",
        });
      },
      facebookShare() {
        this.properties["share platform"] = "Facebook";
        AmplitudeHelper.registerAmplitudeEvent(
          "share resource",
          this.properties
        );
        delete this.properties["share platform"];

        ShareHelper.onFacebook({
          link: this.makePublicLink("Facebook"),
          text: this.getShareText(),
        });
      },
      twitterShare() {
        this.properties["share platform"] = "Twitter";
        AmplitudeHelper.registerAmplitudeEvent(
          "share resource",
          this.properties
        );
        delete this.properties["share platform"];

        ShareHelper.onTwitter({
          url: this.makePublicLink("Twitter") + "\n\n",
          text: this.getShareText(),
          tag: "Resource",
        });
      },
      emailShare() {
        this.properties["share platform"] = "Email";
        AmplitudeHelper.registerAmplitudeEvent(
          "share resource",
          this.properties
        );
        delete this.properties["share platform"];

        window.location =
          "mailto:?body=" +
          this.getShareText() +
          " " +
          this.makePublicLink("Email") +
          " \n" +
          "&subject=I thought this link might interest you.";
      },
      getShareText() {
        var text =
          "Check out this resource on the Eblity platform. I really found it useful and think you could benefit from this";
        return text;
      },
    },
    mounted() {
      this.whatsappUrl =
        "whatsapp://send?text=" +
        this.getShareText() +
        "\n\n " +
        this.makePublicLink("WhatsApp");
    },
  };
</script>

<style scoped>
  .share-heading {
    font-weight: 900;
    font-size: 24px;
    line-height: 36px;
    text-align: center;
    color: #333333;
  }

  .btn-text {
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
  }
</style>
